import { useEffect, useState } from "react";
import useAppHooks from "../../../../../../shared/hooks/useAppHooks";
import RenderMathQuestion from "../../../../../../shared/components/RenderMathQuestion/RenderMathQuestion";
import { optionLables } from "../..";
import "./QuestionCard.css";
import QuestionHeader from "../../Layout/QuestionHeader/QuestionHeader";
import { updateQuestionStatus } from "../../../../../../redux/exam/examSlice";

const QuestionCard = () => {
  const { selector, dispatch } = useAppHooks();
  const state = selector((state) => state.examSlice);

  const [integerAnswer, setIntegerAnswer] = useState("");

  const currentLang = state?.currentLang || "en";

  // Check if we are in gamified practice mode (instant feedback)
  const isPracticeGamified =
    state?.testDetails?.practiceMode === "practice" &&
    state?.testDetails?.gamificationOn === true;

  // Mark current question as active/current
  useEffect(() => {
    if (state?.question?.[0]?.qid) {
      dispatch(
        updateQuestionStatus({
          qid: state.question[0].qid,
          makeCurrent: true,
        })
      );
    }
  }, [dispatch, state?.question]);

  const handleOptionClick = (optionId) => {
    const currentQid = state.question[0].qid;

    dispatch(
      updateQuestionStatus({
        qid: currentQid,
        selectedOption: optionId,
      })
    );
  };

  const handleIntegerInputChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setIntegerAnswer(value);
      dispatch(
        updateQuestionStatus({
          qid: state.question[0].qid,
          integerAnswer: value,
        })
      );
    }
  };

  // Find current question from questionsData (list) for status/selection
  const currentQ = state.questionsData.find(
    (q) => q.qid === state.question?.[0]?.qid
  );

  return (
    <div className="exam__question_card">
      <QuestionHeader />

      <div className="exam__question_card__question">
        {state?.question?.length > 0 && (
          <RenderMathQuestion
            question={
              currentLang === "en"
                ? state.question[0].q_text
                : state.question[0].q_text_hindi
            }
          />
        )}
      </div>

      <div className="exam__question_card__options">
        {state?.question?.[0]?.type === "Single-Correct-Type" ? (
           state?.question?.[0]?.option?.map((opt, index) => {
            const isSelected = currentQ?.selectedOption === opt.option_id;
            const isCorrectOption = opt.is_correct === 1;

            // In gamified practice mode, show immediate feedback after selection
            const showResult = isPracticeGamified && currentQ?.selectedOption;

            let optionClass = "";
            let labelClass = "";

            if (showResult) {
              if (isSelected && isCorrectOption) {
                optionClass = "option-correct";
                labelClass = "label-correct";
              } else if (isSelected && !isCorrectOption) {
                optionClass = "option-wrong";
                labelClass = "label-wrong";
              } else if (!isSelected && isCorrectOption) {
                optionClass = "option-correct";
                labelClass = "label-correct";
              }
            } else if (isSelected) {
              optionClass = "selected";
              labelClass = "selected-label";
            }

            return (
              <div
                key={opt.option_id}
                className={`exam__question_card__option ${optionClass}`}
                onClick={() => handleOptionClick(opt.option_id)}
              >
                <span
                  className={`exam__question_card__option_label ${
                    labelClass || "not-selected-label"
                  }`}
                >
                  {optionLables[index]}
                </span>

                <RenderMathQuestion
                  question={
                    currentLang === "en" ? opt.option : opt.option_hindi
                  }
                />
              </div>
            );
          })
        ) : state?.question?.[0]?.type === "Integer-Type" ? (
          <div className="exam__question_card__integer_input">
            <input
              type="text"
              value={currentQ?.integerAnswer || ""}
              onChange={handleIntegerInputChange}
              placeholder="Enter an integer"
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default QuestionCard;